import type { RealEstatePropertyType } from '../types';

export const REAL_ESTATE_TYPE_OPTIONS: { value: RealEstatePropertyType; label: string }[] = [
  { value: 'apartment', label: 'Apartment' },
  { value: 'house', label: 'House' },
  { value: 'multi_family', label: 'Multi-family' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'land', label: 'Land / plot' },
  { value: 'vacation', label: 'Vacation home' },
  { value: 'other', label: 'Other' },
];

const REAL_ESTATE_TYPE_LABELS = new Map(
  REAL_ESTATE_TYPE_OPTIONS.map((option) => [option.value, option.label])
);

export function realEstateTypeLabel(type: RealEstatePropertyType | undefined): string {
  if (!type) return 'Property';
  return REAL_ESTATE_TYPE_LABELS.get(type) ?? 'Property';
}

const REAL_ESTATE_TYPES = new Set<RealEstatePropertyType>(
  REAL_ESTATE_TYPE_OPTIONS.map((option) => option.value)
);

export function asRealEstatePropertyType(value: unknown): RealEstatePropertyType {
  return typeof value === 'string' && REAL_ESTATE_TYPES.has(value as RealEstatePropertyType)
    ? (value as RealEstatePropertyType)
    : 'other';
}

/** Net equity for a single property: market value minus outstanding mortgage. */
export function propertyEquity(property: {
  currentValue: number;
  mortgageBalance?: number;
}): number {
  const value = Number.isFinite(property.currentValue) ? property.currentValue : 0;
  const mortgage =
    typeof property.mortgageBalance === 'number' && Number.isFinite(property.mortgageBalance)
      ? property.mortgageBalance
      : 0;
  return value - mortgage;
}
